<template>
  <div class="tasks-list__header">
    <h2 v-if="isTasksDataReady" class="tasks-list__title">{{ getTasksTitle }}</h2>
    <div v-else class="tasks-list__title-skeleton"></div>
    <AccentLightButton @click="$emit('task-create-new')">
      <PlusIcon color="#FB923C" class="mr-2" />Додати завдання
    </AccentLightButton>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { friendlyDateName } from '@/shared/lib/date-time';
import { AccentLightButton } from '@/shared/ui/form';
import { PlusIcon } from '@/shared/ui/icons';

export default {
  mixins: [ friendlyDateName ],
  components: { AccentLightButton, PlusIcon },
  computed: {
    ...mapGetters('activeTasksModule', ['getTotalTasksCount', 'getFinishedTasksCount', 'isTasksDataReady', 'getActiveFilters']),
    getTasksTitle() {
      if (this.getActiveFilters.period.start === null && this.getActiveFilters.period.end === null) {
        return 'Всі завдання';
      }

      return `Завдання на ${this.getFriendlyDate([this.getActiveFilters.period.start, this.getActiveFilters.period.end])} ${this.getTotalTasksCount}/${this.getFinishedTasksCount}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.tasks-list {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 8px;
    margin-bottom: 24px;

    @media (max-width: 1200px) {
      flex-direction: column;
      align-items: start;
      padding-top: 0;
      margin-bottom: 16px;
    }
  }

  &__title {
    font-family: inherit;
    font-size: 20px;
    font-weight: 600;

    @media (max-width: 1200px) {
      margin-bottom: 16px;
    }

    &-skeleton {
      width: 200px;
      height: 24px;
      background: #E4E4E4;
      border-radius: 6px;
      background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
      background-size: 200% 100%;
      animation: shimmer 1.4s infinite;

      @media (max-width: 1200px) {
        margin-bottom: 16px;
      }
    }
  }
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
